import { Vue, Prop, Component } from 'vue-property-decorator';
import {
  DeleteTaskMessagesTaskMessageNoRequest,
  GetTaskMessagesTaskMessagesNoDetailsLastRequest,
  GetTaskMessagesRequest,
  PostTaskMessagesTaskMessageNoDetailsRequest,
  DeleteTaskMessagesTaskMessageNoDetailsTaskMessageDetailNoRequest,
  PutTaskMessagesTaskMessageNoComplateRequest,
  PutTaskMessagesTaskMessageNoDetailsTaskMessageDetailNoRequest
} from 'supporter';

function isSameTaskMessageTarget({ fromTargetType, toTargetType }): boolean {
  return fromTargetType === toTargetType;
}

@Component
export default class TaskContentMixin extends Vue {
  @Prop({ required: true })
  private readonly adminInfo;

  @Prop({
    default: (): any => [],
    required: false
  })
  public contentList?: any;
  @Prop({
    default: (): any => [],
    required: false
  })
  public orderProductOptionNoArr?: any;

  @Prop({ default: false, required: false })
  public showAllTask?: boolean;

  public taskMessageStatusTypeArr: any[] = [
    { value: 'PROCESSING', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_STATUS_TYPE_PROCESSING' },
    { value: 'DONE', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_STATUS_TYPE_DONE' }
  ];
  public taskMessageTypeArr: any[] = [
    { value: 'PAY', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_PAY' },
    { value: 'PRODUCT', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_PRODUCT' },
    { value: 'DELIVERY', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_DELIVERY' },
    { value: 'CLAIM', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_CLAIM' },
    { value: 'REFUND', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_REFUND' },
    { value: 'ETC', label: 'ORDER_ORDER_DETAIL_TASK_MESSAGE_TYPE_ETC' }
  ];

  public taskMessageTargetTypeArr: any[] = [
    { value: 'PARTNER', label: 'ORDER_ORDER_DETAIL_MESSAGE_TARGET_TYPE_PARTNER' },
    { value: 'SERVICE', label: 'ORDER_ORDER_DETAIL_MESSAGE_TARGET_TYPE_SERVICE' }
  ];
  public showEdit: boolean = false;
  public taskContentList: any = [];
  public processList: any = [];
  public doneList: any = [];
  public taskTotalNum: number = 0;
  public taskProcessNum: number = 0;

  public clickArrow(item: any): void {
    this.$set(item, 'upArrow', !item.upArrow);
  }
  public saveTask(item: any): void {
    this.getTaskNewestCheck(item).then((): any => {
      if (!item.newOrderProductOptionNo) {
        alert(this.$t('ORDER_CS_TASK_ALERT_1'));
        return;
      }
      if (!item.newContent) {
        alert(this.$t('ORDER_CS_TASK_ALERT_2'));
      }
      let putRequest: any = {
        pathParams: {
          taskMessageNo: item.no.toString()
        },
        data: {
          orderProductOptionNo: item.newOrderProductOptionNo,
          toTargetNo: item.toTargetNo,
          taskMessageType: item.newTaskMessageType,
          toTargetType: item.newTaskMessageTargetType,
          content: item.newContent
        }
      };
      this.$api.putTaskMessagesTaskMessageNo(putRequest).then((): any => {
        alert(this.$t('ORDER_CS_TASK_ALERT_3'));
        this.getTasks();
      });
    });
  }
  public getTasks(): void {
    let taskRequest: GetTaskMessagesRequest = {
      params: {
        orderNo: this.$route.query.orderNo as any
      }
    };
    this.$api.getTaskMessages(taskRequest).then((res): any => {
      this.taskContentList = [];
      this.taskContentList = res.data;
      this.taskTotalNum = this.taskContentList.length;
      this.formatterList(res.data);
    });
  }
  public formatterList(data: any): void {
    if (data.length === 0) {
      return;
    }
    this.doneList = [];
    this.processList = [];
    data.map((item: any): any => {
      if (!(item.toTargetType === 'PARTNER' && item.fromTargetType === 'PARTNER')) {
        this.$set(item, 'contentLength', item.content.length);
        this.$set(item, 'newContent', item.content);
        this.$set(item, 'newTaskMessageStatus', item.taskMessageStatusType);
        this.$set(item, 'newTaskMessageType', item.taskMessageType);
        this.$set(item, 'newTaskMessageTargetType', item.toTargetType);
        this.$set(item, 'newOrderProductOptionNo', item.orderProductOptionNo);
        this.$set(item, 'upArrow', true);
        this.$set(item, 'detailDisabled', false);
        this.$set(item, 'addTaskMessageStatus', item.taskMessageStatusType);
        this.$set(item, 'addContent', null);
        this.$set(item, 'addContentLength', 0);
        if (item.taskMessageDetails.length > 0) {
          this.$set(item, 'detailLastIndex', item.taskMessageDetails.length - 1);
          item.taskMessageDetails.map((dItem: any): any => {
            this.$set(dItem, 'contentLength', dItem.content.length);
            this.$set(dItem, 'newContent', dItem.content);
          });
        }

        const hasTaskMessageDetails = !!item.taskMessageDetails.length;
        const isSameTaskMessagePartnerTarget = item.fromTargetType === 'PARTNER' && isSameTaskMessageTarget(item);

        this.$set(item, 'hasTaskDetail', hasTaskMessageDetails && !isSameTaskMessagePartnerTarget);

        if (item.taskMessageStatusType === 'DONE') {
          this.$set(item, 'upArrow', false);
          this.doneList.push(item);
        } else {
          this.processList.push(item);
        }
      }
    });
    this.doneList = this.doneList.reverse();
    this.processList = this.processList.reverse();
    this.taskProcessNum = this.processList.length;
    this.$emit('taskMessageStatus', this.processList);
  }

  public handleShowAllTaskList(showAll: boolean): void {
    if (this.doneList.length === 0) {
      return;
    }
    this.doneList.map((item: any): any => {
      if (showAll) {
        this.$set(item, 'upArrow', true);
      } else {
        this.$set(item, 'upArrow', false);
      }
    });
  }
  public handleEdit(theItem: any, parentItem?: any): void {
    this.$set(theItem, 'showEdit', true);
    this.$set(theItem, 'detailDisabled', true);
    if (parentItem) {
      this.$set(parentItem, 'detailDisabled', true);
    }
  }
  public handleDelete(item: any): void {
    if (!confirm(this.$t('ORDER_CS_TASK_CONFIRM_1') as any)) {
      return;
    }

    this.getTaskNewestCheck(item).then((): any => {
      let taskDeleteRequest: DeleteTaskMessagesTaskMessageNoRequest = {
        pathParams: {
          taskMessageNo: item.no
        }
      };
      this.$api.deleteTaskMessagesTaskMessageNo(taskDeleteRequest).then((): any => {
        this.getTasks();
      });
    });
  }

  private isLastTaskMessageInDetail(itemTaskMessage: any, currentDetailIndex: number,): boolean {
    return itemTaskMessage.detailLastIndex === currentDetailIndex;
  }

  private isWrittenTaskMessageByMe(detailTaskMessage: any): boolean {
    return String(detailTaskMessage.registerInfo.registerAdminNo) === String(this.adminInfo.no);
  }

  public canUpdateAndDeleteTaskMessage(itemTaskMessage: any, detailTaskMessage: any, currentDetailIndex: number): boolean {
    return this.isLastTaskMessageInDetail(itemTaskMessage, currentDetailIndex) && this.isWrittenTaskMessageByMe(detailTaskMessage);
  }

  public handleAddDetailDelete(item: any): void {
    if (!confirm(this.$t('ORDER_CS_TASK_CONFIRM_1') as any)) {
      return;
    }
    this.getTaskNewestCheck(item).then((res: any): any => {
      let request: DeleteTaskMessagesTaskMessageNoDetailsTaskMessageDetailNoRequest = {
        pathParams: {
          taskMessageNo: item.no,
          taskMessageDetailNo: res.data.no
        }
      };
      this.$api.deleteTaskMessagesTaskMessageNoDetailsTaskMessageDetailNo(request).then((): any => {
        this.getTasks();
      });
    });
  }

  public handleCompleted(item: any): void {
    let message: any = this.$t('ORDER_CS_TASK_CONFIRM_2');
    this.getTaskNewestCheck(item).then((res: any): any => {
      if (res.data) {
        message = this.$t('ORDER_CS_TASK_CONFIRM_3');
      }
      if (!confirm(message)) {
        return;
      }
      let request: PutTaskMessagesTaskMessageNoComplateRequest = {
        pathParams: {
          taskMessageNo: item.no
        },
        data: {
          lastTaskMessageDetailNo: res.data ? res.data.no : 0
        }
      };
      this.$api
        .putTaskMessagesTaskMessageNoComplate(request)
        .then((): any => {
          alert(this.$t('ORDER_CS_TASK_ALERT_4'));
          this.getTasks();
        })
        .catch((): any => {
          alert(this.$t('ORDER_CS_TASK_ALERT_5'));
        });
    });
  }
  public getTaskNewestCheck(item: any): any {
    return new Promise((resolve: any): any => {
      let lastNoIndex: number = item.taskMessageDetails.length - 1;
      let detaiLastlRequest: GetTaskMessagesTaskMessagesNoDetailsLastRequest = {
        pathParams: {
          taskMessageNo: item.no
        }
      };
      this.$api.getTaskMessagesTaskMessagesNoDetailsLast(detaiLastlRequest).then((res: any): any => {
        if (res.data.no === (item.taskMessageDetails[lastNoIndex] && item.taskMessageDetails[lastNoIndex].no)) {
          resolve(res);
        } else {
          alert(this.$t('ORDER_CS_TASK_ALERT_6'));
          return;
        }
      });
    });
  }
  public getFromTargetTypeLabel(type: any): any {
    let label: any = '';
    switch (type) {
      case 'SERVICE':
        label = this.$t('ORDER_CS_TASK_FROM_TARGET_TYPE_SERVICE');
        break;
      case 'PARTNER':
        label = this.$t('ORDER_CS_TASK_FROM_TARGET_TYPE_PARTNER');
        break;
      default:
        label = '';
    }
    return label;
  }
  public getTargetTypeLabel(type: any): any {
    let label: any = '';
    switch (type) {
      case 'SERVICE':
        label = this.$t('ORDER_CS_TASK_TARGET_TYPE_SERVICE');
        break;
      case 'PARTNER':
        label = this.$t('ORDER_CS_TASK_TARGET_TYPE_PARTNER');
        break;
      default:
        label = '';
    }
    return label;
  }
  public getTaskMessageStatusTypeLabel(type: any): any {
    let label: any = '';
    switch (type) {
      case 'PROCESSING':
        label = this.$t('ORDER_CS_TASK_MESSAGE_STATUS_TYPE_PROCESSING');
        break;
      case 'DONE':
        label = this.$t('ORDER_CS_TASK_MESSAGE_STATUS_TYPE_DONE');
        break;
      default:
        label = '';
    }
    return label;
  }
  public getTaskMessageTypeName(csType: any): any {
    let name: any = '';
    switch (csType) {
      case 'PAY':
        name = this.$t('ORDER_CS_TASK_MESSAGE_TYPE_PAY');
        break;
      case 'PRODUCT':
        name = this.$t('ORDER_CS_TASK_MESSAGE_TYPE_PRODUCT');
        break;
      case 'DELIVERY':
        name = this.$t('ORDER_CS_TASK_MESSAGE_TYPE_DELIVERY');
        break;
      case 'CLAIM':
        name = this.$t('ORDER_CS_TASK_MESSAGE_TYPE_CLAIM');
        break;
      case 'REFUND':
        name = this.$t('ORDER_CS_TASK_MESSAGE_TYPE_REFUND');
        break;
      case 'ETC':
        name = this.$t('ORDER_CS_TASK_MESSAGE_TYPE_ETC');
        break;
      default:
        name = '';
    }
    return name;
  }
  public contentInput(ev: any): void {
    if (ev.newContent) {
      ev.contentLength = ev.newContent.length;
    } else {
      ev.contentLength = 0;
    }
  }
  public addContentInput(ev: any): void {
    if (ev.addContent) {
      ev.addContentLength = ev.addContent.length;
    } else {
      ev.addContentLength = 0;
    }
  }
  public handleCancelBtn(item: any): void {
    if (!confirm(this.$t('ORDER_CS_TASK_CONFIRM_4') as any)) {
      return;
    }
    this.$set(item, 'showEdit', false);
    this.$set(item, 'contentLength', item.content.length);
    this.$set(item, 'newContent', item.content);
    this.$set(item, 'newTaskMessageStatus', item.taskMessageStatusType);
    this.$set(item, 'newTaskMessageType', item.taskMessageType);
    this.$set(item, 'newTaskMessageTargetType', item.toTargetType);
    this.$set(item, 'newOrderProductOptionNo', item.orderProductOptionNo);
    this.$set(item, 'detailDisabled', false);
  }
  public detailSave(item: any, detail: any): any {
    if (item.content === '') {
      alert(this.$t('ORDER_CS_TASK_ALERT_7'));
      return;
    }
    this.getTaskNewestCheck(item).then((checkRes: any): any => {
      let request: PutTaskMessagesTaskMessageNoDetailsTaskMessageDetailNoRequest = {
        pathParams: {
          taskMessageNo: item.no,
          taskMessageDetailNo: checkRes.data.no.toString()
        },
        data: {
          lastTaskMessageDetailNo: Number(checkRes.data.no),
          content: detail.newContent
        }
      };
      this.$api.putTaskMessagesTaskMessageNoDetailsTaskMessageDetailNo(request).then((): any => {
        alert(this.$t('ORDER_CS_TASK_ALERT_3'));
        this.getTasks();
      });
    });
  }
  public handleDetailCancel(item: any, parentItem: any): void {
    if (!confirm(this.$t('ORDER_CS_TASK_CONFIRM_4') as any)) {
      return;
    }
    this.$set(item, 'showEdit', false);
    this.$set(item, 'contentLength', item.content.length);
    this.$set(item, 'newContent', item.content);
    this.$set(parentItem, 'detailDisabled', false);
  }
  public addTaskMessageDetail(item: any): any {
    let lastNoIndex: number = item.taskMessageDetails.length - 1;
    let detaiLastlRequest: GetTaskMessagesTaskMessagesNoDetailsLastRequest = {
      pathParams: {
        taskMessageNo: item.no
      }
    };

    this.$api.getTaskMessagesTaskMessagesNoDetailsLast(detaiLastlRequest).then((res: any): any => {
      if (res.data.no === (item.taskMessageDetails[lastNoIndex] && item.taskMessageDetails[lastNoIndex].no)) {
        if (!item.addContent) {
          alert(this.$t('ORDER_CS_TASK_ALERT_8'));
          return;
        }
        if (item.addTaskMessageStatus === 'DONE') {
          if (!confirm(this.$t('ORDER_CS_TASK_CONFIRM_3') as any)) {
            return;
          }
        }
        let request: PostTaskMessagesTaskMessageNoDetailsRequest = {
          pathParams: {
            taskMessageNo: item.no
          },
          data: {
            completion: item.addTaskMessageStatus === 'DONE',
            taskMessageChannelType: 'SERVICE',
            lastTaskMessageDetailNo: res.data ? res.data.no : 0,
            content: item.addContent
          }
        };
        this.$api.postTaskMessagesTaskMessageNoDetails(request).then((): any => {
          if (item.addTaskMessageStatus === 'DONE') {
            alert(this.$t('ORDER_CS_TASK_ALERT_4'));
          } else {
            alert(this.$t('ORDER_CS_TASK_ALERT_9'));
          }
          this.getTasks();
        });
      } else {
        alert(this.$t('ORDER_CS_TASK_ALERT_6'));
        return;
      }
    })
  }
}
